import styles from "@styles/pages/cdp/customers.module.scss";
import { Currency } from "@utils/Currency";
import { Numbers } from "@utils/Numbers";
import { Phone } from "@utils/Phone";

import classNames from "classnames/bind";
import { If } from "shared/components/control-statements";
const css = classNames.bind(styles);

const RFV_LABELS = {
  CAMPEOES: "Campeões",
  HIBERNANDO: "Hibernando",
  PROMISSORES: "Promissores",
  LEAL: "Leal",
  EM_RISCO: "Em risco",
  REQUER_ATENCAO: "Requer atenção",
  DESLIGANDO: "Desligando",
  ABANDONADOS: "Abandonados",
  UNDEFINED: "Indefinido",
};

const css_classes = {
  CAMPEOES: "campeoes",
  HIBERNANDO: "hibernando",
  PROMISSORES: "promissores",
  LEAL: "leais",
  EM_RISCO: "emrisco",
  REQUER_ATENCAO: "naopodemosperder",
  DESLIGANDO: "perfilindefinido",
  ABANDONADOS: "perfilindefinido",
  UNDEFINED: "perfilindefinido",
};

export const Customer = ({ customer, onSelectCustomer, audience }) => {
  const rfv_css_class = css_classes[customer?.rfv_profile || "INDEFINIDO"];

  return (
    <tr
      onClick={() => onSelectCustomer && onSelectCustomer(customer)}
      className={css({ customer: true, table: true })}
      key={customer.id}
    >
      <td>
        <div className="d-flex align-center">
          <div className={styles.icon}>
            <i className="fas fa-phone" />
          </div>
          <p>{Phone.format(customer.phone)}</p>
          <span>/</span>
          <p>{customer.name || "Nome não registrado!"}</p>
        </div>
      </td>
      <If cond={audience?.version !== "V1"}>
        <td className="d-flex align-start">
          <div className={css({ rfv: true, [rfv_css_class]: true })}>
            {RFV_LABELS[customer.rfv_profile] || "Indefinido"}
          </div>
        </td>
      </If>
      <td>
        <p>{Currency.formatCurrency(+customer.total_orders || 0)}</p>
      </td>
      <td>
        <p>{Numbers.formatInt(customer.count_orders)}</p>
      </td>
    </tr>
  );
};
